import { render, staticRenderFns } from "./Cx3CallVaultService.vue?vue&type=template&id=95ef54cc&"
import script from "./Cx3CallVaultService.vue?vue&type=script&lang=js&"
export * from "./Cx3CallVaultService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports